// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"197":"75fc9c18","293":"component---src-pages-index-js","518":"8a28b14e"}[chunkId] || chunkId) + "." + {"197":"1015d3ba61abfdf4af74","293":"e0ca1f6bc3d94520f38d","518":"9221badad1e08d20bbc6","779":"87ab8d75c32b6079c7a1"}[chunkId] + ".js";
};